<template>
  <div :class="containerClass">
    <a
      v-for="locale in locales.toArray()"
      :key="locale"
      :href="(isSelectedLocale(locale))? null : '#'"
      :class="[itemClass, {[activeClass]: isSelectedLocale(locale)}, 'language_switch']"
      @click.prevent="languageItemClickHandler($event, locale)"
    >
      <img
        :src="locale.icon"
        alt=""
        :class="iconClass"
        :title="t(locale.primaryTag)"
        width="22"
        height="15"
      >
      <span :class="labelClass">{{ t(locale.primaryTag) }}</span>
    </a>
  </div>
</template>

<script>
  import { EVENT_LANGUAGE_ITEM_CLICK } from '@events/Toolbar'

  import localeManager from '@services/LocaleManager'
  import LocaleCollection from '@models/Locale/collection'
  import ProfileCollection from '@models/Profile/collection'

  export default {
    props: {
      locales: {
        type: LocaleCollection,
        required: true
      },
      profiles: {
        type: ProfileCollection
      },
      containerClass: {
        type: String
      },
      activeClass: {
        type: String
      },
      itemClass: {
        type: String
      },
      iconClass: {
        type: String
      },
      labelClass: {
        type: String
      }
    },
    locales: {
      'en': {
        'en': 'English',
        'ru': 'Russian'
      },
      'ru': {
        'en': 'English',
        'ru': 'Russian'
      }
    },
    methods: {
      languageItemClickHandler (e, locale) {
        if (!this.isSelectedLocale(locale)) {
          this.changeLocale(locale)
          this.$emit('change', e, locale)
        } else {
          e.stopPropagation()
        }
      },
      isSelectedLocale (locale) {
        return locale.toString() === localeManager.getLocale().toString()
      },
      changeLocale (locale) {
        this.updateToolbarLocale(locale)
        return this
      },
      updateToolbarLocale (locale) {
        this.$translate.setLang(locale.toString())
        this.$sendSystemEvent(EVENT_LANGUAGE_ITEM_CLICK, locale.toString())

        return this
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/LanguageSwitch.vue